import { render } from "./ChangePleskServerForm.vue?vue&type=template&id=87c57c6c"
import script from "./ChangePleskServerForm.vue?vue&type=script&lang=js"
export * from "./ChangePleskServerForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__